import React, { Component, Fragment } from 'react';
//import { Router } from 'react-router'
import { BrowserRouter as Router } from 'react-router-dom'
import { Route, Switch, Redirect, withRouter } from 'react-router'
import Login from './pages/Login'
import AppErrors from './modules/AppErrors'
import RepositorySelect from './pages/RepositorySelect'
import Authorizing from './pages/Authorizing'
import RepositoryEdit from './pages/RepositoryEdit'
import BasicInfoHOC from './modules/BasicInfoHOC'
import AuthorizedHOC from './modules/AuthorizedHOC'
import history from './history'
import injectStyles from 'react-jss'
import Loading from './pages/Loading'

const LoginWithQueryString = withRouter(props => <Login
  {...props}
  queryString={props.history.location.search.slice(1)}
/>)

const RepositoryEditWithRepoName = props => <RepositoryEdit
  {...props}
  urlFriendlyRepoName={props.match.params.repository}
/>

const RepositorySelectWrapper = props => <AuthorizedHOC>
  <BasicInfoHOC loadingElement={<Loading />}>
    <RepositorySelect {...props} />
  </BasicInfoHOC>
</AuthorizedHOC>

const RepositoryEditWithRepoNameWrapper = props => <AuthorizedHOC>
  <BasicInfoHOC loadingElement={<Loading />}>
    <RepositoryEditWithRepoName {...props} />
  </BasicInfoHOC>
</AuthorizedHOC>

const styles = {
  '@global': {
    'body': {
      fontFamily: "'Roboto', sans-serif",
      color: '#4f4f4f',
      margin: 0,
    },
    'html': {
      backgroundColor: '#f9fafa',
    },
    'h1,h2,h3,h4': {
      fontWeight: 'normal',
    },
    'input, textarea, select, button': {
      fontFamily: "'Roboto', sans-serif",
    },
    'a, a:link': {
      fontSize: 24,
      cursor: 'pointer',
      color: 'inherit',
      textDecoration: 'none',
    },
    'input': {
      backgroundColor: 'white',
      border: '1px solid #dee1e5',
    },
  }
}

class App extends Component {
  render() {
    return (
      <Router /*history={history}*/>
        <WithRouter>
          <Fragment>
            <AppErrors />
            <Route path="/login" component={LoginWithQueryString} />
            <Route path="/authorizing" component={Authorizing} />
            <Route path="/select-repository" component={RepositorySelectWrapper} />
            <Route path="/repo/:repository" component={RepositoryEditWithRepoNameWrapper} />
            <Route exact path="/" component={() => <Redirect to="/login" />} />
          </Fragment>
        </WithRouter>
      </Router>
    );
  }
}

const WithRouter = withRouter(props => props.children)

export default injectStyles(styles)(App)



// WEBPACK FOOTER //
// ./src/App.js